<template>
  <div>
    <ReturnBtn
      :path="this.path ? this.path : `subskrypcja`"
      blackColor
    ></ReturnBtn>
    <h1 class="section-title" style="text-align: center; margin-top: 40px">
      {{ workshop ? workshop.name : "" }}
    </h1>
    <v-row class="card">
      <v-col v-if="workshop && !loading">
        <video-player
          :videoId="getCourseYoutubeId()"
          :dropboxLink="getCourseDropboxLink"
        />
      </v-col>
      <div class="text-under">
        <p
          v-html="workshop ? htmlToFormattedText(workshop.description) : ''"
        ></p>
      </div>
    </v-row>
  </div>
</template>

<script>
import ReturnBtn from "../components/ReturnBtn.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
import { getYoutubeIdFromUrl } from "../utils";

export default {
  name: "SequencingWorkshopVideo",

  components: {
    ReturnBtn,
    VideoPlayer,
  },

  data: () => ({
    playing: true,
    loggedIn: false,
    path: null,
    loading: false,
    workshop: null,
  }),

  async created() {
    try {
      this.loading = true;
      const workshopId = this.$route.params.id;
      this.path = this.$route.params.path;
      const workshopResponse = await this.$store.dispatch(
        "sequencingWorkshops/fetchSequencingWorkshopItem",
        workshopId
      );
      this.workshop = workshopResponse;
      if (!this.workshop) {
        this.redirectToWorkshopsView();
      }
      const workshopResponseId = workshopResponse
        ? workshopResponse.sequencingWorkshopId
        : "";

      const isPaid = await this.$store.dispatch(
        "sequencingWorkshops/checkUserPaidForWorkshop",
        workshopResponseId
      );
      if (!isPaid) {
        this.redirectLogin();
      } else {
        const isNotExpired = await this.$store.dispatch(
          "sequencingWorkshops/checkTariffWorkshopIsNotExpired",
          this.workshop.sequencingWorkshopId
        );

        if (!isNotExpired) {
          this.redirectToWorkshopsView();
        }
      }
    } catch (error) {
      console.log(error);
      this.redirectLogin();
      this.$store.dispatch(
        "snackbar/setSnackbar",
        {
          color: "red",
          icon: "exclamation-triangle",
          message:
            "Musisz być zalogowany oraz posiadać wykupiony dostęp do warsztatów",
        },
        { root: true }
      );
      this.$store.dispatch("snackbar/toggleSnackbar", true, { root: true });
    } finally {
      this.loading = false;
    }
  },

  methods: {
    redirectLogin(signup) {
      this.$router.push({
        name: "Auth",
        params: { name: "", signup: signup },
      });
    },

    redirectToWorkshopsView() {
      this.$router.push({
        name: "SequencingWorkshops",
        params: { id: this.workshop.sequencingWorkshopId },
      });
    },
    htmlToFormattedText(text) {
      const regex =
        /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g;
      text = text.replace(regex, '<a href="$1">$1</a>');
      return text;
    },

    getCourseYoutubeId() {
      return getYoutubeIdFromUrl(this.workshop.videoLink);
    },

    moveToAuth() {
      this.$router.push({
        name: "Auth",
        params: { previousPage: "WorkshopsVideos" },
      });
    },
  },

  computed: {
    getCourseDropboxLink() {
      const videoLink =
        this.workshop && this.workshop.videoLinkDropbox
          ? this.workshop.videoLinkDropbox.replace("dl=0", "raw=1")
          : "";
      return videoLink;
    },
  },
};
</script>

<style scoped>
.card {
  width: 70vw;
  margin: 0 auto;
  display: block;
  position: relative;
  color: #54514c;
  position: relative;
  margin: auto;
  margin-top: 30px;
}
.text-under {
  padding: 20px 10px;
}
h3 {
  margin-bottom: 20px;
  font-size: 1.3rem;
  font-weight: 400;
}

.no-access .btn-gradient {
  width: 220px;
  padding: 8px 22px;
  border-radius: 30px;
  font-size: 1rem;
  margin: 15px;
}
.no-access {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  padding-top: 3rem;
  height: 100%;
  min-height: 300px;
  max-height: 600px;
  width: 80%;
  margin: 0 auto;
  background-image: url("../assets/background-video.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.switch {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
}
.switch div {
  padding: 1rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  font-size: 15px;
  cursor: pointer;
}
.switch .btn-gradient {
  height: 40px;
  display: flex;
  align-items: center;
  background: rgb(233, 230, 230);
  color: black;
}
.switch .btn-gradient:hover {
  transform: none;
}
.selectedSwitch {
  background: rgb(179, 106, 103) !important;
  background: linear-gradient(
    90deg,
    rgba(179, 106, 103, 1) 0%,
    rgba(223, 44, 38, 1) 100%
  ) !important;
  color: #fff !important;
}
@media screen and (max-width: 700px) {
  .card {
    width: 90vw;
  }
}
@media screen and (max-width: 550px) {
  .no-access h3 {
    font-size: 1.1rem;
  }
}
@media screen and (max-width: 450px) {
  .no-access .btn-gradient {
    font-size: 0.8;
    width: 160px;
  }
  .no-access h3 {
    font-size: 1rem;
  }
  .card {
    width: 100vw;
  }
  .text-under {
    font-size: 0.8rem;
    padding: 20px 5px;
  }
}
@media screen and (max-width: 375px) {
  .no-access h3 {
    font-size: 0.8rem;
  }
}
</style>
